import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

export const openCalendarSchedulingDialogMutator: (sourceId: string) => void = mutatorAction("OPEN_CALENDAR_SCHEDULING_DIALOG", 
// sourceId is not used yet; it will be used for telemetry once that is implemented.
(_sourceId: string): void => {
    getStore().isOpen = true;
});

export const closeCalendarSchedulingDialogMutator: () => void = mutatorAction("CLOSE_CALENDAR_SCHEDULING_DIALOG", (): void => {
    getStore().isOpen = false;
});
